// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.translation-buttons-container {
  margin: -20px 45px 0 0;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
}

.translation-buttons-container-main {
  margin: -20px 25px 0 0;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  flex-direction: column;
}
.translation-buttons-container-main .button-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin-top: 5px;
}
.translation-buttons-container-main .experimental-text {
  position: relative;
  bottom: -8px;
  right: 5px;
  display: flex;
  flex-direction: row;
  font-size: 0.7rem;
  justify-content: flex-end;
}

.translation-button {
  border-radius: 3px;
  box-shadow: 0.1rem 0.15rem 0.3rem 0 #525151;
  background-color: white;
  border: none;
  color: #0669B3;
  font-size: 0.7em;
  font-weight: 600;
  height: 22px;
  margin-left: 10px;
  margin-top: 5px;
  transition: 0.1s ease;
  width: 80px;
}
.translation-button:hover {
  background: #63AEDE;
  color: white;
  color: black;
  font-weight: 500;
}
.translation-button:active {
  color: #D1D3D4;
}

.translation-buttons-container-interrupt {
  margin: 10px auto -50px;
  width: 98%;
  display: flex;
  justify-content: flex-end;
}

.translation-button-interrupt {
  border-radius: 5px;
  border: none;
  font-size: 0.9em;
  background: #EDEDED;
  color: black;
  width: 100px;
  height: 25px;
  transition: 0.1s ease;
  margin-left: 5px;
  margin-right: 5px;
  margin-top: 10px;
}
.translation-button-interrupt:hover {
  transform: scale(1.1);
  background: #D1D3D4;
}
.translation-button-interrupt:active {
  color: #444343;
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/TranslationButton.scss","webpack://./src/styles/global/GlobalMixins.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACI,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;AAUJ;;AARA;EACI,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,sBAAA;AAWJ;AAVI;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AAYR;AAVI;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,yBAAA;AAYR;;AARA;EC9BI,kBD+BsB;ECVtB,2CAAA;EDYA,uBAAA;EACA,YAAA;EACA,cDLS;ECMT,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;AAWJ;AAVI;EACI,mBDZQ;ECaR,YAAA;EACA,YAAA;EACA,gBAAA;AAYR;AAVI;EACI,cD1BA;ACsCR;;AARA;EACI,uBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;AAWJ;;AATA;EC5DI,kBD6DsB;EACtB,YAAA;EACA,gBAAA;EACA,mBDnDI;ECoDJ,YAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AAYJ;AAVI;EACI,qBAAA;EACA,mBDnDA;AC+DR;AAVI;EACI,cDjDC;AC6DT","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/GlobalMixins\";\n\n.translation-buttons-container {\n    margin: -20px 45px 0 0;\n    display: flex;\n    justify-content: flex-end;\n    flex-wrap: nowrap;\n}\n.translation-buttons-container-main {\n    margin: -20px 25px 0 0;\n    display: flex;\n    justify-content: flex-end;\n    flex-wrap: nowrap;\n    flex-direction: column;\n    .button-container {\n        display: flex;\n        flex-direction: row;\n        flex-wrap: wrap;\n        justify-content: flex-end;\n        margin-top: 5px;\n    }\n    .experimental-text {\n        position: relative;\n        bottom: -8px;\n        right: 5px;\n        display: flex;\n        flex-direction: row;\n        font-size: 0.7rem;\n        justify-content: flex-end;\n    }\n}\n\n.translation-button {\n    @include borderRadius(3px);\n    @include shadow();\n    background-color: white;\n    border: none;\n    color: $pearl-blue;\n    font-size: 0.7em;\n    font-weight: 600;\n    height: 22px;\n    margin-left: 10px;\n    margin-top: 5px;\n    transition: 0.1s ease;\n    width: 80px;\n    &:hover {\n        background: $lt-pearl-blue;\n        color: white;\n        color: black;\n        font-weight: 500;\n    }\n    &:active {\n        color: $grey1\n    }\n}\n\n.translation-buttons-container-interrupt {\n    margin: 10px auto -50px;\n    width: 98%;\n    display: flex;\n    justify-content: flex-end;\n}\n.translation-button-interrupt {\n    @include borderRadius(5px);\n    border: none;\n    font-size: .9em;\n    background: $white;\n    color: black;\n    width: 100px;\n    height: 25px;\n    transition: 0.1s ease;\n    margin-left: 5px;\n    margin-right: 5px;\n    margin-top: 10px;\n\n    &:hover {\n        transform: scale(1.1);\n        background: $grey1;\n    }\n    &:active {\n        color: $grey4a;\n    }\n}\n","@import \"./Colors.scss\";\n\n@mixin borderRadius($radius: 5px) {\n    border-radius: $radius;\n}\n\n@mixin dialogueBold() {\n    font-weight: 600;\n    font-size: .9em;\n}\n\n@mixin input() {\n    border-radius: 5px;\n    font-weight: 400;\n    width: 100%;\n}\n\n@mixin infoRounded($radius) {\n    background: $information;\n    border-bottom-left-radius: $radius;\n    border-bottom-right-radius: $radius;\n}\n\n@mixin shadow() {\n    box-shadow: 0.1rem 0.15rem 0.3rem 0 $shadow;\n}\n@mixin shadowBottom() {\n    box-shadow: 0 0.1rem 0.15rem 0 $shadow;\n}\n@mixin standardInputContainer() {\n    font-weight: 500;\n    font-size: .9rem;\n    margin: 10px 0;\n}\n@mixin standardInput() {\n    @include borderRadius(5px);\n    border: none;\n    border: 1px solid $grey3;\n    padding: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
